import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'

import FadeEntry from 'ui/components/generic/FadeEntry'
import Button from 'ui/components/generic/Button'
import { BodyText as Text } from 'ui/styles/utils'
import Links from 'ui/components/generic/Links'

const Wrapper = styled.div`
  padding: 100px 0;
  background-color: #fff;
`

const SlotMachine = styled.div`
  position: relative;
  margin-top: 50px;
  margin-bottom: 50px;
`

const Btn = styled.div`
  width: 100px;
  height: 100px;
  color: #fff;
  margin-left: 100px;
  background-image: url('/slotmachine.png');
  background-size: contain;

  img {
    width: 100%;
    transform: translateX(-90px) translateY(-50px);
    transition: 1s;
    transform-origin: bottom right;
  }

  &:active {
    img {
      transform: translateX(-90px) translateY(-20px) rotate(-90deg);
    }
  }
`

const Label = styled.div`
  position: absolute;
  top: -80px;
  left: 100px;
  transform: rotate(-30deg);
  text-transform: uppercase;
`

class BodyText extends Component {
  state = {
    poelse: null,
    dressings: null
  }

  componentDidMount() {
    window.addEventListener('keypress', e => {
      if (e.code === 'Space') {
        this.generate()
      }
    })
  }

  getDressing = selected => {
    const dressings = [
      'Fransk dressing',
      'Ketchup',
      'Chili kethcup',
      'Karry ketchup',
      'Remoulade',
      'Sennep',
      'Chili sauce'
    ]
    return dressings[Math.floor(Math.random() * dressings.length)]
  }

  getPoelse = selected => {
    const poelser = [
      'Jalapeño og cheddar pølse',
      'Chilipølse',
      'Ostepølse',
      'Frankfurter',
      'Vildsvinepølse',
      'Medister',
      'Pølse i svøb',
      'Grillpølse',
      'Krasser',
      'Jalapeño og cheddar pølse',
      'Chilipølse',
      'Ostepølse',
      'Frankfurter',
      'Vildsvinepølse',
      'Medister',
      'Pølse i svøb',
      'Grillpølse'
    ]

    return poelser[Math.floor(Math.random() * poelser.length)]
  }

  getName = () => {
    const { poelse, dressings } = this.state

    if (!dressings || !poelse) return ''

    let nationality
    let character

    switch (poelse) {
      case 'Jalapeño og cheddar pølse':
        nationality = 'Mexicaner'
        break

      case 'Chilipølse':
        nationality = 'Brian Nielsen'
        break

      case 'Ostepølse':
        nationality = 'Schweitzer'
        break

      case 'Frankfurter':
        nationality = 'Tysker'
        break

      case 'Vildsvinepølse':
        nationality = 'Polak'
        break

      case 'Medister':
        nationality = 'Flemming Bamse'
        break

      case 'Pølse i svøb':
        nationality = 'Baron'
        break

      case 'Grillpølse':
        nationality = 'Tyroler'
        break

      case 'Krasser':
        nationality = 'Uldsok'
        break

      default:
        nationality = poelse
    }

    character = dressings
      .map(d => {
        switch (d) {
          case 'Fransk dressing':
            return 'alpehue'
          case 'Ketchup':
            return 'klaphat'
          case 'Chili kethcup':
            return 'sombrero'
          case 'Karry ketchup':
            return 'turban'
          case 'Remoulade':
            return 'sydvest'
          case 'Sennep':
            return 'uldhue'
          case 'Chili sauce':
            return 'sombrero'
          default:
            return d
        }
      })
      .join(' og ')

    // custom combinations
    if (
      poelse === 'Chilipølse' &&
      dressings.filter(f => 'Karry ketchup').length > 1
    ) {
      return 'Dobbelt Bombay'
    } else if (poelse === 'Chilipølse' && dressings.includes('Karry ketchup')) {
      return 'Bombay'
    }

    return nationality + ' med ' + character
  }

  generate = () => {
    const numberOfDressings = Math.abs(Math.random() * 2)

    const dressings = []

    const poelse = this.getPoelse()

    while (dressings.length < numberOfDressings) {
      dressings.push(this.getDressing(dressings))
    }

    this.setState({
      poelse,
      dressings
    })
  }

  render() {
    const { poelse, dressings } = this.state

    let isTheSameDressing = false
    if (dressings && dressings[0] === dressings[1]) {
      isTheSameDressing = true
    }

    const name = this.getName()

    return (
      <Wrapper>
        <Container fluid>
          <SlotMachine>
            <Label>← Træk i pølsearmen</Label>
            <Btn onClick={this.generate} onTouchStart={this.generate}>
              <img src="/sausage.png" />
            </Btn>
          </SlotMachine>
          <h1>{name}</h1>
          {poelse && (
            <h2>
              ({poelse} med{' '}
              {isTheSameDressing
                ? `meget ${dressings[0]}`
                : dressings.join(' og ')}
              )
            </h2>
          )}
        </Container>
      </Wrapper>
    )
  }
}

export default BodyText



// WEBPACK FOOTER //
// ./src/ui/components/modules/PoelseHjul/index.js